import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import DateSection from './formSections/date';
import DescriptionSection from './formSections/description';
import ShopSection from './formSections/shop';
import ImagesSection from './formSections/images';
import CheckboxesSection from './formSections/checkboxes';
import CommunicationsCheckboxes from './formSections/communicationsCheckboxes';

import { useTranslation } from 'react-i18next';

import usePromotions from '../usePromotions';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';
import FormHelper from 'helpers/FormHelper';
import { useState } from 'react';

const EditPromotion = ({ isNew }) => {
  const { t } = useTranslation();
  const [isSelectedFiles, setIsSelectedFiles] = useState(false);
  const {
    singleItem,
    form,
    updateInProcess,
    handleCreateOrUpdate,
    handleApproveOrReject,
    handleApprove,
    marketingContractors,
    shoppingCenters,
    companyCategories,
    handleDeleteFile,
    filterData,
    isShoppingCenter,
  } = usePromotions(false);

  const staffOnly = Form.useWatch('staff_only', form);

  console.log('staffOnly=', staffOnly);

  const onFinish = async (params) => {
    await handleCreateOrUpdate(params);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('PUBBLICA PROMOZIONE') : t('MODIFICA PROMOZIONE');

  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title_it: '',
            title_en: '',
            title_fr: '',
            author: '',
            staff_only: false,
            description_it: '',
            description_en: '',
            description_fr: '',
            marketing_approved: '',
            retail_approved: '',
            published: '',
            shopping_center_id: '',
            contractor_ids: [],
            company_category_ids: [],
            is_archive: false,
            is_newsletter: false,
            is_radio: false,
            is_social: false,
            is_web: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={(changedFields) => {
            if (changedFields?.length) {
              const field = changedFields[0];
              if (field.name[0] === 'image' || field.name[0] === 'video_clip') {
                if (field.value.length) {
                  setIsSelectedFiles(true);
                  form.setFields([
                    {
                      name: 'image',
                      errors: [],
                    },
                    {
                      name: 'video_clip',
                      errors: [],
                    },
                  ]);
                } else {
                  setIsSelectedFiles(false);
                }
              }
            }
            const fieldName = changedFields?.[0]?.name?.[0];
            const descriptionFields = [
              'description_it',
              'description_en',
              'description_fr',
            ];

            if (!descriptionFields.includes(fieldName)) {
              FormHelper.resetFormsFieldErrors(form)(changedFields);
            }
          }}
        >
          <InfoSection isView={isApproveOnly} form={form} />
          <DateSection isView={isApproveOnly} />
          <DescriptionSection isView={isApproveOnly} form={form} />
          <ShopSection
            isView={isApproveOnly}
            companyCategories={companyCategories}
            shoppingCenters={shoppingCenters}
            shops={filterData?.companies || []}
            inactiveShops={filterData?.inactive_companies || []}
            isShoppingCenter={isShoppingCenter}
          />
          <ImagesSection
            isSelectedFiles={isSelectedFiles}
            form={form}
            isView={isApproveOnly}
            updateInProcess={updateInProcess}
            handleDeleteFile={handleDeleteFile}
            singleItem={singleItem}
            isEdit={!isNew}
          />
          <CheckboxesSection isView={isApproveOnly} />
          <CommunicationsCheckboxes
            isStaffOnly={staffOnly}
            isView={isApproveOnly}
          />
          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  loading={updateInProcess}
                  icon={<CheckOutlined />}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
          {!isNew && (
            <NotificationFormForEdit
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_admin}
              showRefuse={!!singleItem.can_refuse}
              approveKey={'publish'}
              rejectKey={'unpublish'}
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default EditPromotion;
